module.exports={
	"Form": "ProductEditManifest",
	"Scope": "Product-Edit",
	"Descriptors":
	{
		"ProductDetails.Name":
		{
			"Name": "Name",
			"Hash": "Product-Edit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "Product-Edit-Identity",
				"Group": "Product-Edit-Identity"
			}
		},
		"ProductDetails.ManufacturerCode":
		{
			"Name": "Manufacturer Code",
			"Hash": "Product-Edit-ManufacturerCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 4,
				"Section": "Product-Edit-Identity",
				"Group": "Product-Edit-Identity"
			}
		},
		"ProductDetails.CatalogCode":
		{
			"Name": "Catalog Code",
			"Hash": "Product-Edit-CatalogCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "Product-Edit-Identity",
				"Group": "Product-Edit-Identity"
			}
		},
		"ProductDetails.AcceptanceMethod":
		{
			"Name": "Acceptance Method",
			"Hash": "Product-Edit-AcceptanceMethod",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "Product-Edit-Details",
				"Group": "Product-Edit-Details"
			}
		},
		"ProductDetails.ProductCategory":
		{
			"Name": "Product Category",
			"Hash": "Product-Edit-ProductCategory",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "Product-Edit-Details",
				"Group": "Product-Edit-Details"
			}
		},
		"ProductDetails.EffectiveDate":
		{
			"Name": "Effective Date",
			"Hash": "Product-Edit-EffectiveDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "Product-Edit-Details",
				"Group": "Product-Edit-Details"
			}
		},
		"ProductDetails.ExpirationDate":
		{
			"Name": "Expiration Date",
			"Hash": "Product-Edit-ExpirationDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "Product-Edit-Details",
				"Group": "Product-Edit-Details"
			}
		},
		"ProductDetails.Comments":
		{
			"Name": "Comments",
			"Hash": "Product-Edit-Comments",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "5",
				"Width": 12,
				"Section": "Product-Edit-Details",
				"Group": "Product-Edit-Details"
			}
		},
		"ProductDetails.IDMaterial":
		{
			"Name": "Material",
			"Hash": "Product-Edit-IDMaterial",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "6",
				"Width": 4,
				"Section": "Product-Edit-Details",
				"Group": "Product-Edit-Details",
				"Entity": "Material",
				"SearchFields":
				[
					"Name",
					"MaterialCode",
					"ItemCode"
				]
			}
		},
		"ProductDetails.IDOrganization":
		{
			"Name": "Organization",
			"Hash": "Product-Edit-IDOrganization",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "6",
				"Width": 4,
				"Section": "Product-Edit-Details",
				"Group": "Product-Edit-Details",
				"Entity": "Organization",
				"SearchFields":
				[
					"Name",
					"VendorCode",
					"FederalTaxCode"
				]
			}
		},
		"ProductDetails.IDProduct":
		{
			"Name": "IDProduct",
			"Hash": "Product-Edit-IDProduct",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "Product-Edit-DataAudit",
				"Group": "Product-Edit-DataAudit"
			}
		},
		"ProductDetails.GUIDProduct":
		{
			"Name": "GUIDProduct",
			"Hash": "Product-Edit-GUIDProduct",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "Product-Edit-DataAudit",
				"Group": "Product-Edit-DataAudit"
			}
		},
		"ProductDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "Product-Edit-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "Product-Edit-DataAudit",
				"Group": "Product-Edit-DataAudit"
			}
		},
		"ProductDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "Product-Edit-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "Product-Edit-DataAudit",
				"Group": "Product-Edit-DataAudit"
			}
		},
		"ProductDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "Product-Edit-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "Product-Edit-DataAudit",
				"Group": "Product-Edit-DataAudit"
			}
		},
		"ProductDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "Product-Edit-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "Product-Edit-DataAudit",
				"Group": "Product-Edit-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "Product-Edit-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "Product-Edit-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "Product-Edit-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "Product-Edit-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "Product-Edit-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "Product-Edit-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
